import React, { useMemo } from "react";
import { contentTypes } from "../../config/constants";
import List from "../global/list";
import { getString } from "../../utilities";
import { useWidthSize } from "../../hooks";
import { isFreeGame } from "../../utilities/games";
import { dataSelector } from "../../redux/slices/dataSlice";
import { useSelector } from "react-redux";

export default function FeatureList({ featuredList, gradeNumber, gradeGames }) {
  const { lists } = useSelector(dataSelector);
  const gameList = useMemo(() => {
    if (featuredList) {
      const featuredGames = featuredList.items.map((item) => ({
        type: contentTypes.game,
        title: item.game.fullname,
        path: item?.game?.localeShortname ? item.game.localeShortname : item.game.shortname,
        image: item.game.miniBanner ? item.game.miniBanner : null,
        grades: item.game.grades,
        mobile: item.game.mobileActive,
        searchable: item.game.searchable,
        id: item.game.id,
      }));
      // Sort the featuredGames by free game first and then other games in the featured game list
      const freeGames = [];
      const otherGames = [];
      featuredGames.forEach((item) => {
        if (isFreeGame(lists, item.id)) {
          freeGames.push(item);
        } else {
          otherGames.push(item);
        }
      });
      // Find all free games in the current grade
      const allFreeGames = gradeGames.filter((game) => isFreeGame(lists, game?.id));
      // Add free games which are not in the freeGames array yet, using same format as freeGames elements
      allFreeGames.forEach((game) => {
        if (!freeGames.some((freeGame) => freeGame.id === game.id)) {
          freeGames.push({
            type: contentTypes.game,
            title: game?.fullname,
            path: game?.localeShortname ? game?.localeShortname : game?.shortname,
            image: game?.miniBanner ? game?.miniBanner : null,
            grades: game?.grades,
            mobile: game?.mobileActive,
            searchable: game?.searchable,
            id: game?.id,
          });
        }
      });

      return [...freeGames, ...otherGames];
    }
    return [];
  }, [featuredList, gradeGames, lists]);

  const showFullTitle = useWidthSize(["xxs", "xs"]);

  // if browser width size is "sm" (640px) or higher show full title
  const featureTitle = !showFullTitle ? featuredList?.title : getString("grades.featured");

  return (
    <div className="feature-list-container">
      <List title={featureTitle} items={gameList} className={`feature-list grade-feature-${gradeNumber}`} />
    </div>
  );
}
